import { closeTopDialog } from '../components/ui';
import { activeCall } from './activeCall';

/**
 * Sent on `window` when Android's back button is pressed during a call. The
 * call's screen takes it (preventDefault) and asks whether to leave; nothing
 * else on screen does.
 */
export const BACK_DURING_CALL = 'meetdost:back';

export type BackOutcome = 'dialog' | 'call' | 'back' | 'background';

/**
 * What one press of Android's back button (or the back gesture) does, in
 * order: it closes the dialog on top; during a call it asks whether to leave
 * the meeting, rather than leaving it; otherwise it goes back a page; on the
 * first page it puts the app in the background, as Android apps do, rather
 * than doing nothing. Without this, the web view went back a page, which left
 * a call without asking.
 */
export function handleBackButton(canGoBack: boolean, actions: { back: () => void; background: () => void }): BackOutcome {
  if (closeTopDialog()) return 'dialog';
  if (activeCall.get() && !window.dispatchEvent(new Event(BACK_DURING_CALL, { cancelable: true }))) return 'call';
  if (canGoBack) {
    actions.back();
    return 'back';
  }
  actions.background();
  return 'background';
}
